import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex text-gray-800" }
const _hoisted_2 = { class: "w-10 pl-3" }

import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { PersonStores, useAuthStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordButton',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();
const authStore = useAuthStore();
const confirmResetPasswordOpen = ref(false);
const toast = useToast();

const onCancelResetPassword = () => (confirmResetPasswordOpen.value = false);

const openConfirmResetPassword = () => (confirmResetPasswordOpen.value = true);

const onResetPassword = () => {
  authStore
    .forgotPassword({ email: profileStore.person?.user?.email, causer_id: authStore.user?.id })
    .then((response) => {
      if (response.data.success) {
        doSuccess(response.data.message);
      } else {
        doWarn(response.data.message);
      }
    })
    .catch((error) => doFail(error.data.message));

  confirmResetPasswordOpen.value = false;
};

const doSuccess = (detail: string) => {
  toast.add({
    severity: 'success',
    summary: 'Reset Link Sent',
    detail: detail,
    life: 3000,
  });
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'warn',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

const doWarn = (detail: string) => {
  toast.add({
    severity: 'warn',
    detail: detail,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (confirmResetPasswordOpen.value)
      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
          key: 0,
          header: "Reset Password",
          "accept-label": "Reset Password",
          onAccept: onResetPassword,
          onCancel: onCancelResetPassword
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, {
                name: "warning",
                class: "confirm-dialog-icon text-gray-600"
              }),
              _createElementVNode("span", _hoisted_2, _toDisplayString(`Are you sure you want to Reset ${_unref(profileStore).person?.display_name}'s Password?`), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_AppButton, {
      type: "secondary",
      text: "Reset Password",
      "icon-left": "vpn_key",
      onClick: openConfirmResetPassword
    })
  ]))
}
}

})